import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

const HERO_BG = "https://images.pexels.com/photos/12537427/pexels-photo-12537427.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_innovate-ghana-tech/artifacts/0dmqxsnu_0e0a97331ac163b7d8d3f4fa458da7ea9f7b5c35ae763d1673b82962b564a212.png";

export default function HeroSection() {
  const { t } = useLang();
  const scrollTo = (id) => { const el = document.querySelector(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <section id="accueil" data-testid="hero-section" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B] via-[#0B132B]/90 to-[#0B132B]/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-transparent to-transparent" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="animate-fade-in-up">
              <span className="inline-block px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#00D186] border border-[#00D186]/30 rounded-sm mb-8">{t.hero.badge}</span>
            </div>
            <h1 className="animate-fade-in-up animation-delay-200 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none text-white mb-6">
              {t.hero.title1}{' '}<span className="text-gradient">{t.hero.title2}</span><br />{t.hero.title3}
            </h1>
            <p className="animate-fade-in-up animation-delay-400 text-lg md:text-xl font-light leading-relaxed text-white/70 max-w-2xl mb-10">{t.hero.desc}</p>
            <div className="animate-fade-in-up animation-delay-600 flex flex-wrap gap-4">
              <button onClick={() => scrollTo('#services')} data-testid="hero-cta-services" className="inline-flex items-center gap-2 px-8 py-4 bg-[#00D186] text-[#0B132B] font-bold tracking-wide rounded-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-[#00D186]/20">
                {t.hero.cta1}<ArrowRight size={18} />
              </button>
              <button onClick={() => scrollTo('#produits')} data-testid="hero-cta-ecosystem" className="inline-flex items-center gap-2 px-8 py-4 border border-white/30 text-white font-bold tracking-wide rounded-sm transition-all duration-300 hover:bg-white hover:text-[#0B132B]">
                {t.hero.cta2}
              </button>
            </div>
            <div className="animate-fade-in-up animation-delay-800 mt-16 grid grid-cols-3 gap-8 max-w-lg">
              <div><div className="text-3xl font-black text-white">8+</div><div className="text-sm text-white/50 mt-1">{t.hero.stat1}</div></div>
              <div><div className="text-3xl font-black text-white">100+</div><div className="text-sm text-white/50 mt-1">{t.hero.stat2}</div></div>
              <div><div className="text-3xl font-black text-white">5+</div><div className="text-sm text-white/50 mt-1">{t.hero.stat3}</div></div>
            </div>
          </div>
          {/* Logo on the right */}
          <div className="hidden lg:flex items-center justify-center animate-fade-in animation-delay-400">
            <div className="relative">
              <div className="w-80 h-80 rounded-3xl bg-white/10 backdrop-blur-sm border border-white/10 flex items-center justify-center p-8 animate-float">
                <img src={LOGO_URL} alt="GIT NFT GHANA LTD" className="w-full h-full object-contain drop-shadow-2xl" data-testid="hero-logo" />
              </div>
              <div className="absolute -inset-4 rounded-3xl bg-[#00D186]/10 blur-2xl -z-10" />
            </div>
          </div>
        </div>
      </div>
      <button onClick={() => scrollTo('#apropos')} data-testid="hero-scroll-down" className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/40 hover:text-[#00D186] transition-colors animate-float">
        <ChevronDown size={32} />
      </button>
    </section>
  );
}
